import { LoggerStream, LoggerStreamExecuteOptions, LogLevel } from '../Logger';

export class ConsoleStream implements LoggerStream {
    constructor(
        protected console: any = window.console,
        protected colorsEnabled: boolean = true
    ) {
    }

    exec(options: LoggerStreamExecuteOptions) {

        let method;

        switch(options.level){

            case LogLevel.LOG:
                method = 'log';
                break;
            case LogLevel.INFO:
                method = 'info';
                break;
            case LogLevel.WARN:
                method = 'warn';
                break;
            case LogLevel.ERROR:
                method = 'error';
                break;
        }

        let optionArgs = options.args || [];
        let args = [];

        if(this.colorsEnabled){

            let tagBackgroundColor = this.generateHex(options.tag);
            let tagTextColor = this.getIdealTextColor(tagBackgroundColor);

            args = ['%c ' + options.tag + ' ', 'background: ' + tagBackgroundColor + '; color: ' + tagTextColor + ';'].concat(optionArgs);
        }
        else {

            args = [options.tag].concat(optionArgs);
        }

        this.console[method].apply(this.console, args);
    }

    protected generateHex(input) {

        // str to hash
        for(var i = 0, hash = 0; i < input.length; hash = input.charCodeAt(i++) + ((hash << 5) - hash)) ;

        // int/hash to hex
        for(var i = 0, colour = '#'; i < 3; colour += ('00' + ((hash >> i++ * 8) & 0xFF).toString(16)).slice(-2)) ;

        return colour;
    }

    protected getIdealTextColor(bgColor) {

        let r = bgColor.substring(1, 3);
        let g = bgColor.substring(3, 5);
        let b = bgColor.substring(5, 7);

        let components = {
            R: parseInt(r, 16),
            G: parseInt(g, 16),
            B: parseInt(b, 16)
        };

        let nThreshold = 105;
        let bgDelta = (components.R * 0.299) + (components.G * 0.587) + (components.B * 0.114);

        return ((255 - bgDelta) < nThreshold) ? '#000000' : '#ffffff';
    }
}
